import _ from 'lodash';

import * as types from './types';

/**
 * Structure used for a dialog object
  {
    message: '',
    title: '',
    show: false,
    showCancel: false,
    actionsToDispatchOnOk: null,
    actionsToDispatchOnCancel: null,
    priority: 0,
    okButtonText // optional, will default to Ok
  }
 */
export const INITIAL_STATE = {
  dialogQueue: [],
  yesNoDialogProps: { showDialog: false },
};

const comparator = (a1, a2) => {
  return a1.title === a2.title && a1.message === a2.message;
};

export default (state = INITIAL_STATE, { type, payload }) => {
  switch (type) {
    case types.ADD_NOTIFICATION_DIALOGS:
      return {
        ...state,
        dialogQueue: _.orderBy(
          _.uniqWith([...payload, ...state.dialogQueue], comparator),
          'priority',
          'desc'
        ),
      };
    case types.SET_NOTIFICATION_DIALOG:
      return {
        ...state,
        dialogQueue: _.orderBy(
          _.uniqWith([payload, ...state.dialogQueue], comparator),
          'priority',
          'desc'
        ),
      };

    case types.CLOSE_NOTIFICATION_DIALOG: {
      const { index = 0, type = null } = payload;
      return {
        ...state,
        dialogQueue: state.dialogQueue.filter((dq, i) =>
          type ? dq.type !== type : index !== i
        ),
      };
    }
    case types.CLOSE_ALL_NOTIFICATION_DIALOG: {
      return {
        ...state,
        dialogQueue: [],
      };
    }

    // Yes No Dialog
    case types.SET_YES_NO_DIALOG_PROPS: {
      return {
        ...state,
        yesNoDialogProps: payload,
      };
    }
    case types.RESET_YES_NO_DIALOG_PROPS: {
      return {
        ...state,
        yesNoDialogProps: INITIAL_STATE.yesNoDialogProps,
      };
    }

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/components/dialogs/state/reducer.js